import { CommonModule } from '@angular/common';
import { AfterViewInit, Component, OnDestroy, OnInit, ViewChild } from '@angular/core';
import { NavigationEnd, Router, RouterModule } from '@angular/router';
import { TranslateModule } from '@ngx-translate/core';
import { OverlayPanel, OverlayPanelModule } from 'primeng/overlaypanel';
import { NavigateToDirective } from 'projects/shared/directives/navigator.directive';
import { ICart, ICartItem } from 'projects/shared/models/interfaces/cart.model';
import { BrowserService } from 'projects/shared/services/browser.service';
import { CartService } from 'projects/shared/services/cart.service';
import { StoreChangesService } from 'projects/shared/services/store-changes.service';
import { LanguageService } from 'projects/shop/src/app/+shared/services/language.service';
import { filter, noop, Subscription, tap } from 'rxjs';

@Component({
  selector: 'app-nav-cart',
  standalone: true,
  imports: [CommonModule, RouterModule, OverlayPanelModule, TranslateModule, NavigateToDirective],
  templateUrl: './nav-cart.component.html',
  styleUrl: './nav-cart.component.scss'
})
export class NavCartComponent implements OnInit, AfterViewInit, OnDestroy {

  @ViewChild('cartOP') cartOP!: OverlayPanel;

  cartQuantity = 0;

  cart!: ICart;

  updatedCart: any[] = [];


  _subscription = new Subscription()

  constructor(
    private _storeChangesService: StoreChangesService,
    private _cartService: CartService,
    private _browserService: BrowserService,
    private _router: Router,
    private _languageService: LanguageService
  ) { }

  ngOnInit(): void {
    this.getCart();
    this.cartCounter()
  }

  ngAfterViewInit(): void {
    this._browserService.getWindow()?.addEventListener('scroll', this.closeOnScroll.bind(this), true);
  }

  inCheckoutPage(): boolean {
    return !!this._browserService.getLocation()?.pathname.includes('checkout')
  }

  navigateToCart() {
    this._router.navigate([`/${this.appLanguage()}/settings/cart`])
  }

  getCart() {
    this._subscription.add(
      this._cartService.getCart().pipe(
        tap(
          cart => {
            this.cart = cart;
            // this._storeChangesService.setCart(cart);
          }
        )
      ).subscribe(noop)
    )

    this._subscription.add(
      this._storeChangesService.getCart().pipe(
        filter(cart => cart !== null),
        tap(
          cart => {
            this.cart = cart!;
          }
        )
      ).subscribe(noop)
    )
  }

  cartCounter() {
    this._subscription.add(
      this._storeChangesService.getCartNumber().pipe(
        tap(
          res => {
            this.cartQuantity = res;
          }
        )
      ).subscribe(noop)
    )

    this._subscription.add(
      this._cartService.getCartNumber().pipe(
        tap(
          res => {
            this.cartQuantity = res.totalQuantity;
            this._storeChangesService.setCartNumber(this.cartQuantity);
          }
        )
      ).subscribe(noop)
    )
  }

  navigate(path: string) {
    this.cartOP.hide();
    setTimeout(() => {
      this._router.navigate([`${path}`]);
    }, 50);
  }

  removeItem(item: ICartItem, index: number) {
    this.cart.discount = item.discount - (item.discount / item.quantity)
    this.cartQuantity -= item.quantity;
    this.cart.total -= item.price + item.fees;
    this.cart.products.splice(index, 1);
    this._storeChangesService.setCart(this.cart)
    this.updatedCart = this.cart.products.map((prod: ICartItem) => {
      return {
        product: prod.product,
        quantity: prod.quantity,
        rangePrice: prod.rangePrice,
        userInputs: prod.userInputs,
      };
    });
    !this.updatedCart.length ? this.updatedCart = [] : this.updatedCart;

    this._subscription.add(
      this._cartService.addToCart(this.updatedCart, []).pipe(
        tap(
          res => {
            
          }
        )
      ).subscribe(noop)
    )

  }

  checkoutPageIsOpen() {
    let open = false;
    this._subscription.add(
      this._router.events.subscribe(
        res => {
          if (res instanceof NavigationEnd) {
            open = res.urlAfterRedirects.includes('checkout');
          }
        }
      )
    )
    return open;
  }

  appLanguage() {
    let lang = 'en'
    this._languageService.arabic.subscribe(
      res => {
        lang = res ? 'ar' : 'en'
      }
    )
    return lang;
  }

  closeOnScroll(event: Event) {
    const overlayEl = document.querySelector('.p-overlaypanel');
    if (overlayEl && overlayEl.contains(event.target as Node)) return;

    // لو الـ scroll برره — قفل
    if (this.cartOP?.overlayVisible) {
      this.cartOP.hide();
    }
  }

  ngOnDestroy(): void {
    this._subscription.unsubscribe();
    this._browserService.getWindow()?.removeEventListener('scroll', this.closeOnScroll.bind(this), true);
  }

}
